const localStoreSession = localStorage.getItem('session');

const defaultInitState = {
  authToken: '',
  isAuthorised: false,
  id: '',
  firstname: '',
  lastname: '',
  avatar: ''
};

const initState = () => {
  if(!localStoreSession) {
    return defaultInitState;
  }else {
    return {...defaultInitState, ...JSON.parse(localStoreSession)};
  }
};

const session = (state=initState(), action) => {
  switch (action.type) {

    case "UPDATE_USER_FULL_NAME":
      localStorage.setItem('session', JSON.stringify({
        ...state, ...{firstname: action.payload.firstname, lastname: action.payload.lastname}
      }));
      return {...state, ...{firstname: action.payload.firstname, lastname: action.payload.lastname}};

    case "UPDATE_USER_AVATAR":
      const updateAvatar = `${state.avatar}?${new Date().getTime()}`;

      localStorage.setItem('session', JSON.stringify({
        ...state, ...{avatar: updateAvatar}
      }));
      return {...state, ...{avatar: updateAvatar}};

    case "INIT_SESSION":
      const avatar = `${action.payload.avatar}?${new Date().getTime()}`;

      localStorage.setItem('session', JSON.stringify({
        authToken: action.payload.token,
        isAuthorised: true,
        id: action.payload.id,
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
        avatar,
        scope: action.payload.scope,
      }));
      return {
        authToken: action.payload.token,
        isAuthorised: true,
        id: action.payload.id,
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
        avatar,
        scope: action.payload.scope,
      };

    case "CLEAR_SESSION":
      localStorage.removeItem('session');
      return {...defaultInitState};

    default:
      return state;
  }
}

export default session;
